import { render } from "./system-communications.vue?vue&type=template&id=525386ab&ts=true"
import script from "./system-communications.vue?vue&type=script&lang=ts"
export * from "./system-communications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__